import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import './index.css';
import App from './App';

// Session cookie + Django CSRF header on every request, including the bare
// axios.get/post calls used throughout the feature components.
axios.defaults.withCredentials = true;
axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFToken';
// axios only auto-attaches the XSRF header on same-origin requests unless
// told otherwise. Prod is same-origin (Caddy proxies both from one domain),
// so this was never needed there -- but local dev (frontend :3000, backend
// :8000) is cross-origin, which silently dropped the header on every
// mutating request post-login (still same-site, so the cookie itself is
// sent fine; only this opt-in axios header was missing).
axios.defaults.withXSRFToken = true;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
